(function (angular, app) {
   "use strict";

   angular.module(app.modules.invitation.name)
      .controller(app.modules.invitation.routes.invited.controller, YourInvitedController);
   
   YourInvitedController.$inject = ["$scope", "$q", "$routeParams"
      , app.modules.common.services.functions
      , app.modules.common.services.storage
      , app.modules.common.services.eventbus
      , app.modules.invitation.services.invite
      , app.modules.group.services.groups
      , app.modules.outing.services.outings
      , app.modules.ui.services.alerts
      , app.modules.common.constants.appsettings
      , app.modules.ui.services.ui
   ];

   function YourInvitedController($scope, $q, $routeParams
     , ggFunctions
     , ggStorage
     , ggEvents
     , ggInvitationSvc
     , ggGroupSvc
     , ggOutingSvc
     , ggAlertSvc
     , ggSettings
     , ggUI
   ) {

      $scope.PopupAlert = new ggAlertSvc.popup;

      var ctrl = this;
      this.isLoaded = false;

      this.token = null;

      $scope.Invitation = null;

      $scope.Default = {
         isApp : false
         , isGroup : false
         , isOuting : false
         , isError: false
         , isMember : false
         , group: {
             groupId: 0
            , membershipId: 0
            , isComplete : false


         }
         , outing: {
             outingId: 0
            , playerId: 0
            , isComplete : false
         }
      }

      $scope.f = {
         formatDateString: function (d) {
            return ggFunctions.formatDateString(d, "m/d/yyyy",null);
         }
         , inApp: function (userAgent) {
            setTimeout(function () {
               if (userAgent == "android") {
                  window.location = app.Branding.androidURL;
               } else {
                  window.location = app.Branding.iosURL;
               }
               
            }, 25);
            window.location = app.Branding.appURL;
         }
         , notFound: function () {
            ggFunctions.toggleProcessing(false);
            ctrl.isLoaded = true;
            $scope.PopupAlert.fail("", "The invitation could not display.");
            $scope.Default.isError = true;
         }
         , close: function () {
            var pg = app.modules.view.routes.intro.path;
            ggFunctions.goToPage(pg);
         }
         , accept: function () {

            var isError = false;
            var msg = "";

            // Invitation
            var updateInvitation = function () {
               var form = {
                  id: $scope.Invitation.id
                  , responseType: ggInvitationSvc.responseTypes.accept
                  , memberId: app.Member.Detail.id
               };
               return ggInvitationSvc.invite.updateInvitationResponse(form).then(function (data) {
                  ggEvents.broadcast(app.modules.common.events.invitationUpdate, form);
                  return;
               }, function (error) {
                  isError = true;
                  msg = "There was an error updating the invitation response.";
                  return;
               });
            }
            // Group Membership
            var updateGroupMembership = function () {
               if ($scope.Invitation.groupId && $scope.Invitation.groupId > 0) {
                  return ggGroupSvc.membership.autoJoinGroup({ groupId: $scope.Invitation.groupId, memberId: app.Member.Detail.id }).then(function (data) {
                     if (data && (data.status == "200" || data.status == "201")) {
                        ggStorage.set(ggStorage.keys.groups.my.isCurrent, false); // Not current local groups
                     }
                     return;
                  }, function (error) {
                     isError = true;
                     msg = "There was an error updating the group membership.";
                     return;
                  });
               } else {
                  return $q;
               }
            }
            // Outing Membership
            var updateOutingMembership = function () {
               if ($scope.Invitation.outingId && $scope.Invitation.outingId > 0){
                  return ggOutingSvc.player.autoJoinOuting({ outingId: $scope.Invitation.outingId, memberId: app.Member.Detail.id }).then(function (data) {
                     return;
                  }, function (error) {
                     isError = true;
                     msg = "There was an error updating the player record.";
                     return;
                  });
               }else{
                  return $q;
               }
            }
            // Refresh Member Token
            var refreshMemberToken = function () {
               return app.Member.Authenticate.RefreshToken();
            }

            

            // Process
            ggFunctions.toggleProcessing(true);
            updateInvitation().then(function () {
               return updateGroupMembership()
            }).then(function () {
               return refreshMemberToken();
            }).then(function () {
               return updateOutingMembership();
            }).finally(function () {
               ggFunctions.toggleProcessing(false);

               if (!isError) {
                  if ($scope.Invitation.outingId && $scope.Invitation.outingId > 0) {
                     var btn = new ggAlertSvc.button;
                     btn.name = "Continue";
                     btn.path = app.modules.outing.routes.detail.path + "?outingId=" + $scope.Invitation.outingId;
                     $scope.PopupAlert.success("Perfect!", "Thanks for joining.  Tap continue to view more outing details.", [btn]);
                  } else {
                     var btn = new ggAlertSvc.button;
                     btn.name = "Continue";
                     btn.path = app.modules.group.routes.detail.path + "?groupId=" + $scope.Invitation.groupId;
                     $scope.PopupAlert.success("Perfect!", "Thanks for joining the group.  Tap continue to see a list of group outings.", [btn]);
                  }
               } else {
                  $scope.PopupAlert.fail("Error", msg);
               }
               

            });


         }
         , reject: function () {
            var form = {};
            form.id = $scope.Invitation.id;
            form.responseType = ggInvitationSvc.responseTypes.reject;
            ggFunctions.toggleProcessing(true);
            ggInvitationSvc.invite.updateInvitationResponse(form).then(function (data) {
               ggFunctions.toggleProcessing(false);
               if (data && data.status == "200") {
                  
                  ggEvents.broadcast(app.modules.common.events.invitationUpdate, form);

                  $scope.PopupAlert.fail("Bummer!", "Thanks for your response.  Maybe next time.");
                  $scope.Default.isError = true;
               }
            }, function (error) {
               ggFunctions.toggleProcessing(false);
               if (error) {
                  $scope.PopupAlert.warn("Oops.", "There was an error responding to the invitation.");
                  $scope.Default.isError = true;
               }


            });
         }
         , preview: function () {
            if ($scope.Default.isGroup && !$scope.Default.isOuting) {
               ggFunctions.goToPage(app.modules.group.routes.detail.path + "?groupId=" + $scope.Invitation.groupId);
            }
            if ($scope.Default.isOuting) {
               ggFunctions.goToPage(app.modules.outing.routes.detail.path + "?outingId="+$scope.Invitation.outingId);
            }
         }
      }

      if (app.Member && app.Member.Auth && app.Member.Auth.isAuthenticated) {
         $scope.Default.isMember = true;
      }

      // Check fosr Token
      if ($routeParams) {
         if (!$routeParams.t) {
            // No token -> Go Home
            $scope.f.notFound();
         } else {
            // Get token from
            ctrl.token = $routeParams.t;

            ggFunctions.toggleProcessing(true);
            ggInvitationSvc.search.fetchInvitationDetail({ invitationId: ctrl.token }).then(function (data) {
               if (data && data.status == "200") {
                  $scope.Invitation = data.data;

                  if ($scope.Invitation.type == "Group") {
                     $scope.Default.isGroup = true;
                  }

                  if ($scope.Invitation.type == "Outing" || $scope.Invitation.outingId > 0) {
                     $scope.Default.isOuting = true;
                  }

                  if (!$scope.Default.isGroup && !$scope.Default.isOuting) {
                     $scope.Default.isApp = true;
                  }

                  if ($scope.Invitation.responseType != "NoResponse") {
                     //$scope.PopupAlert.warn("", "The invitation has expired.");
                      $scope.Default.isError = true;
                  }

                  if (!app.Member.Auth.isAuthenticated) {
                     if ($scope.Invitation.email) {
                        app.Member.Auth.userName = $scope.Invitation.email;
                        if ($routeParams.ft) {
                           app.Member.Auth.password = ggSettings.defaultPassword;
                        }
                     }
                  }
               }
            }, function (error) {
               $scope.PopupAlert.warn("", "There was an error fetching the invitation.");
               $scope.Default.isError = true;
            }).finally(function () {
               ggFunctions.toggleProcessing(false);
               ctrl.isLoaded = true;
            });
         }
      }
      ggFunctions.scrollToTop(0);
   }
}(angular, app));

